/* JQF Signature Edge motion
   - Hero/banner art scales 1 -> 1.055 and drifts up 2% while its section scrolls out (scroll-linked, smoothed).
   - Edge rails drift apart up to 8px; gold hairlines/flares brighten slightly mid-scroll.
   - Elements marked [data-jqf-reveal] (and the theme's own sections below the fold) fade/rise in once.
   - Everything is disabled for prefers-reduced-motion, and re-initialises on Shopify theme editor section reloads.
   No external libraries. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 750px)');
  const root = document.documentElement;
  let scenes = [];
  let observer;
  let ticking = false;

  const clamp = (n, a, b) => Math.min(b, Math.max(a, n));

  function collectScenes() {
    scenes = [...document.querySelectorAll('[data-jqf-scene]')]
      .filter((el) => el.dataset.jqfAnimate !== 'false')
      .map((el) => ({
        el,
        art: el.querySelector('.jqf-dark__art'),
        current: 0,
      }));
  }

  function frame() {
    ticking = false;
    const vh = window.innerHeight || 1;
    let again = false;
    for (const s of scenes) {
      const r = s.el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      // 0 when the section top is at the viewport top, 1 when its bottom reaches the top
      const target = clamp(-r.top / Math.max(r.height, 1), 0, 1);
      s.current += (target - s.current) * 0.18; // smoothing (~scrub 0.7)
      if (Math.abs(target - s.current) > 0.001) again = true;
      const p = s.current;
      if (s.art) {
        s.art.style.transform = `translate3d(0, ${(-2 * p).toFixed(3)}%, 0) scale(${(1 + 0.055 * p).toFixed(4)})`;
        // Gold highlights gently brighten toward mid-scroll and settle again (no strobe, no loop).
        s.el.style.setProperty('--jqf-gold-lum', (0.82 + 0.18 * Math.sin(Math.PI * Math.min(p * 1.6, 1))).toFixed(3));
        if (desktop.matches) {
          s.el.style.setProperty('--jqf-rail-shift-l', `${(-8 * p).toFixed(2)}px`);
          s.el.style.setProperty('--jqf-rail-shift-r', `${(8 * p).toFixed(2)}px`);
        }
      }
    }
    if (again) request();
  }

  function request() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(frame);
    }
  }

  function setupReveals() {
    if (observer) observer.disconnect();
    // Auto-mark theme sections below the hero so the whole site shares the same entrance motion.
    document.querySelectorAll('main .shopify-section:not(:first-child) .section > .group-block, main .jqf-work__item, main .jqf-est__step, main .product-card')
      .forEach((el, i) => {
        if (!el.hasAttribute('data-jqf-reveal')) {
          el.setAttribute('data-jqf-reveal', '');
          el.style.setProperty('--jqf-delay', `${(i % 4) * 70}ms`);
        }
      });
    const items = document.querySelectorAll('[data-jqf-reveal]:not(.jqf-in)');
    observer = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('jqf-in');
            observer.unobserve(e.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach((el) => {
      // Anything already on screen at load is shown immediately (never hide above-the-fold content).
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) el.classList.add('jqf-in');
      else observer.observe(el);
    });
  }

  function init() {
    if (reduce.matches) {
      root.classList.remove('jqf-motion-ready');
      document.querySelectorAll('.jqf-dark__art').forEach((a) => (a.style.transform = ''));
      return;
    }
    root.classList.add('jqf-motion-ready');
    collectScenes();
    setupReveals();
    request();
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  reduce.addEventListener?.('change', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
